import { ua } from ".";

export const isMobile = (() => {
  return ua.getDevice().type === "mobile";
})();

/** 判断是否为5+app */
export const isApp = (() => {
  return !!window.plus;
})();
